import { HTTP as http } from '../../http'

const PREFIX = '/rates'

export default {
    create: (data) => {
        return http.post(PREFIX+'/create', data)
    },

    getListByProductId: (data, id) => {
        return http.post(PREFIX+'/list/'+id, data)
    }
}